export default "__VITE_ASSET__CWXOS0a4__"